import Modifier from 'ember-modifier';
import { isDestroying } from '@ember/destroyable';
import { inject as service } from '@ember/service';
import { registerDestructor } from '@ember/destroyable';
import { isCalendlyEvent } from 'sh-www/services/calendly';
import { trackEvent } from 'sh-www/utils/datalayer';

import config from 'sh-www/config/environment';

const cleanup = (instance) => {
  if (instance.calendlyCallback) {
    window.removeEventListener('message', instance.calendlyCallback);
  }
};

class CalendlyModifier extends Modifier {
  #initialized = false;

  @service
  calendly;

  constructor(props) {
    super(props);
    registerDestructor(this, cleanup);
  }

  modify(element, _, { name, email, utmCampaign }) {
    if (this.#initialized) {
      return;
    }

    this.#initialized = true;

    window.addEventListener('message', this.calendlyCallback = (event) => {
      if (isCalendlyEvent(event) && event.data.event === 'calendly.event_scheduled') {
        trackEvent(this, 'generate_lead', {
          campaign: {
            source: 'storyhunter',
            medium: 'website',
            name: utmCampaign,
          }
        });
      }
    });

    (async () => {
      await this.calendly.load();

      if (isDestroying(this)) {
        return;
      }

      Calendly.initInlineWidget({
        url: `${config.calendly.url}?hide_landing_page_details=1&hide_event_type_details=1&hide_gdpr_banner=1&text_color=212121&primary_color=0F0F0F`,
        parentElement: element,
        prefill: {
          name: name ?? '',
          email: email ?? '',
        },
        utm: {
          utmSource: 'storyhunter',
          utmMedium: 'website',
          utmCampaign,
        }
      });
    })();
  }
}

export default CalendlyModifier;
